import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_pa-3 _tac _flexcol _ai-c _gap-2" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption _tc--lighter" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Layout.WebPushEnableParagraph), 1 /* TEXT */),
    _createVNode(_component_base_button, {
      theme: "accent",
      size: "micro",
      class: "_ttl",
      onClick: _withModifiers(_ctx.onEnablePush, ["prevent"]),
      "data-qa": "notification-box-button:EnablePushNotifications"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushEnableButton), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onClick"]),
    _createElementVNode("button", {
      class: "gfu-btn__text _tc--accent",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onMessageHide && $options.onMessageHide(...args)))
    }, _toDisplayString(_ctx.Resources.Layout.HideThisMessageButton), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.Resources.Layout.WebPushAdjustPreferencesParagraph) + " ", 1 /* TEXT */),
      _createElementVNode("a", {
        class: "_tc--accent",
        href: $options.subscriptionManagmentUrl,
        onClick: _cache[1] || (_cache[1] = (...args) => ($options.onLinkClick && $options.onLinkClick(...args))),
        "data-qa": "notification-box-button:CommunicationPreferences"
      }, _toDisplayString(_ctx.Resources.Layout.CommunicationPreferencesLink), 9 /* TEXT, PROPS */, _hoisted_3),
      _cache[2] || (_cache[2] = _createTextVNode(". ", -1 /* CACHED */))
    ]),
    _createVNode(_component_progress_overlay, {
      visible: _ctx.isProcessing,
      sticky: ""
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}